export default __webpack_public_path__ + "static/media/dis-03@2x.d3656d9d.jpg";